<div class="flex flex-col min-h-screen bg-cover bg-center"
     style="background-image: url('assets/images/register-org/final-background.jpg');">
  <div class="flex-1 flex items-center justify-center py-6 px-4 sm:px-6 lg:px-8">
    <div
      class="max-w-6xl w-full flex flex-col md:flex-row bg-white shadow-lg rounded-lg overflow-hidden transition-all duration-300 ease-in-out">

      <!-- Left Side Image (Logo removed from here) -->
      <div
        class="hidden md:block w-full md:w-1/2 bg-gradient-to-br from-purple-100 to-purple-200 p-8 bg-cover bg-center"
        style="background-image: url('assets/images/register-org/second.jpg');">
      </div>

      <!-- Right Side Form -->
      <div class="w-full md:w-1/2 flex flex-col justify-center p-6 sm:p-8 bg-white">

        <!-- Enlarged Logo Above Welcome Text -->
        <div class="flex justify-center mb-6">
          <img src="assets/images/logo/arni-updated-logo.png" alt="Volmint Logo"
               style="width: 150px">
        </div>

        <!-- Welcome Text -->
        <div class="text-center mb-6">
          <h2 class="text-3xl font-bold text-gray-800 mb-1" *ngIf="formType === 'login'"
              style="font-family: var(--vex-font)">
           Volmint
          </h2>
          <h2 class="text-3xl font-bold text-gray-800 mb-1" *ngIf="formType === 'signIn'"
              style="font-family: var(--vex-font)">
            Join Us!
          </h2>
          <p class="text-gray-600 text-md" style="font-family: var(--vex-font)">
            Scholarship Exam
          </p>
        </div>

        <!-- Login Form -->
        <form [formGroup]="loginForm" class="space-y-6" *ngIf="formType === 'login'">

          <!-- Contact Field -->
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Contact</mat-label>
            <input matInput placeholder="Enter Your Contact" formControlName="contact" required type="number">
            <small class="text-red-500" *ngIf="submitted && loginForm.get('contact').hasError('required')">
              Contact is required
            </small>
            <small class="text-red-500" *ngIf="submitted && loginForm.get('contact')?.errors?.minlength">
              Contact must be at least {{ loginForm.get('contact')?.errors?.minlength?.requiredLength }} characters long
            </small>
          </mat-form-field>

          <!-- DOB Field -->
           <mat-form-field appearance="outline" class="w-full">
             <mat-label>Date of Birth</mat-label>
             <input matInput type="text" formControlName="dob" placeholder="DD-MM-YYYY" required>
             <small class="text-red-500" *ngIf="submitted && loginForm.get('dob').hasError('required')">
               Date of Birth is required
             </small>
             <small class="text-red-500" *ngIf="submitted && loginForm.get('dob')?.errors?.minlength">
               Date of Birth must be at least {{ loginForm.get('dob')?.errors?.minlength?.requiredLength }} characters long
             </small>
           </mat-form-field>
          <!--<mat-form-field appearance="fill" class="w-full">
            <mat-label>Date of Birth</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="dob" required>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>-->
          <span class="text-warn-500" style="margin-top: -25px; margin-left: 10px">
            Enter Date of Birth in DD-MM-YYYY format only
          </span>
          <p class="text-bold text-center" style="margin-left: 10px; color: #3b3be4 !important;">
            Note : If your Date of Birth is not registered with us, then use <br> "01-01-2000" in Date of Birth field.
          </p>

          <!-- Remember Me -->
          <div class="flex items-center justify-between">
            <mat-checkbox color="primary">Remember Me</mat-checkbox>
          </div>

          <!-- Login Button -->
          <button (click)="login()" mat-raised-button color="primary"
                  class="w-full py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition">
            Log In
          </button>

          <!-- Register Link -->
          <p class="text-center text-gray-600 text-sm">
            Don't have an account?<br />
            <a class="text-blue-500 cursor-pointer hover:underline" (click)="goTo('auth/register')">
              Register Now
            </a>
          </p>
        </form>
      </div>
    </div>
  </div>
</div>
